import styled from 'styled-components';

type StyledProps = {
    $accentColor: string;
};

export default styled.div<StyledProps>`
    counter-reset: order;
    font-size: 0.75rem;
    flex: 1;
    overflow: auto;
    gap: var(--spacing-8);

    &,
    & .dot-indicator {
        display: flex;
        flex-direction: column;
    }
    .dot-indicator {
        position: relative;
        padding-left: 1rem;
        gap: 0.125rem;

        &:before,
        &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 0.125rem;
        }

        &:after {
            border-radius: 50%;
            background-color: ${({ $accentColor }) => $accentColor};
            width: 0.5625rem;
            height: 0.5625rem;
        }

        &:before {
            width: 0.25rem;
            border-right: 1px solid var(--surface-level-2-line-color);
            box-sizing: content-box;
            bottom: 0.25rem;
        }

        & :first-child {
            font-weight: 800;
            margin-bottom: 0.25rem;
        }
    }
`;
